import { GrHostMaintenance } from 'react-icons/gr';
import ChildHeader from '../../components/ui/ChildHeader';
import { RenderTiles } from '../../components/common';
import { CgPlayListSearch } from 'react-icons/cg';

const tiles = [
  {
    sNo: 1,
    link: '/common/qualityChecksheets/noiseMonitoringReportList',
    isLink: true,
    icon: <GrHostMaintenance size="5rem" color="#003566" />,
    p: 'Noise Monitoring',
    span: 'CheckSheet',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/qualityChecksheets/luxMonitoringReportList',
    isLink: true,
    icon: <GrHostMaintenance size="5rem" color="#003566" />,
    p: 'Lux Monitoring',
    span: 'CheckSheet',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/common/qualityChecksheets/machineSafetyCheckSheetsList',
    isLink: true,
    icon: <GrHostMaintenance size="5rem" color="#003566" />,
    p: 'Machine Safety',
    span: 'CheckSheet',
    isIcon: true,
  },
  {
    sNo: 8,
    link: '/common/qualityChecksheets/pokaYokeCheckSheetList',
    isLink: true,
    icon: <CgPlayListSearch size="5rem" color="#003566" />,
    p: 'POKA YOKE',
    span: 'CHECK SHEET',
    isIcon: true,
  },
  {
    sNo: 9,
    link: '/common/qualityChecksheets/pokaYokeMachineCheckList',
    isLink: true,
    icon: <CgPlayListSearch size="5rem" color="#003566" />,
    p: 'POKA YOKE (MACHINE)',
    span: 'CHECK SHEET',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/common/hpdcChecksheets/operatorChecksheet',
  //   isLink: true,
  //   icon: <GrHostMaintenance size="5rem" color="#003566" />,
  //   p: 'Operator Checksheet',
  //   span: 'List',
  //   isIcon: true,
  // },
  // {
  //   sNo: 2,
  //   link: '/common/hpdcChecksheets/supervisorChecksheet',
  //   isLink: true,
  //   icon: <GrHostMaintenance size="5rem" color="#003566" />,
  //   p: 'Supervisor Checksheet',
  //   span: 'List',
  //   isIcon: true,
  // },
];

const HPDCChecksheetsHome = () => {
  return (
    <>
      <ChildHeader text="QUALITY CHECKSHEETS" />
      <RenderTiles tilesObj={tiles} />
    </>
  );
};

export default HPDCChecksheetsHome;
